import { useSelector as useReduxSelector, TypedUseSelectorHook } from 'react-redux'
import { configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import thunk from 'redux-thunk'

import { authSlice } from 'modules/auth'
import { userSlice } from 'modules/user'
import { contextSlice } from 'modules/context'
import { redirectTheBuyer, addUserToSentry } from '../middlewares'
import { IRootState } from './redux.interfaces'

const rootReducer = {
  auth: authSlice.reducer,
  user: userSlice.reducer,
  context: contextSlice.reducer
}

export const storeFactory = (preloadedState?: IRootState) =>
  configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        [addUserToSentry, redirectTheBuyer, thunk, process.env.NODE_ENV !== 'production' && logger].filter(Boolean)
      ),
    devTools: process.env.NODE_ENV !== 'production'
  })
export const store = storeFactory()
export const useSelector: TypedUseSelectorHook<IRootState> = useReduxSelector
export type AppDispatch = typeof store.dispatch
